import type { ReactNode } from 'react';

interface Props {
  /** what the empty list means + what to do next (ctAS §6.7) */
  children: ReactNode;
  icon?: ReactNode;
}

/* ctAS §6.7 — never show a blank table. Centered, muted, with the
   next action bolded inline by the caller. */
export default function EmptyState({ children, icon }: Props) {
  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-12 px-4 text-muted">
      {icon && <div style={{ color: 'var(--scpa-text-muted)' }}>{icon}</div>}
      <p className="text-[13px] max-w-md leading-relaxed">{children}</p>
    </div>
  );
}
